<template>
  <ankh-list :show-search-form="false">
    <template #btn-group>
      <el-button @click.native="showDialog = true">{{$t('新增')}}</el-button>
    </template>

    <template #table="{height}">

      <table-list
          ref="list"
          :height="height"
          @query="handleSearch"
          :search-params="searchForm"
          :data="tableData"
          @selection-change="selection = $event">

        <el-table-column align="center" type="selection" width="50"/>

        <el-table-column align="center" prop="name" :label="$t('地区服务器')" fixed/>
        <el-table-column align="center" prop="recommendName" :label="$t('推荐值算法')" fixed/>
        <el-table-column align="center" prop="name" :label="$t('默认展示')">
          <template v-slot="{row}">
            <el-switch v-model="row.isDefault" inactive-value="no" active-value="yes" @change="handleChangeStatus($event, row)" />
          </template>
        </el-table-column>
        <el-table-column align="center" prop="releaseTime" :label="$t('创建时间')">
          <template v-slot="{row}">
            {{row.createTime | formatDate}}
          </template>
        </el-table-column>
        <el-table-column fixed="right" :label="$t('操作')" align="center">
          <template v-slot="{row}">
            <div class="fb-gap-10 flex-center">
              <el-link :underline="false" type="primary" @click="handleEdit(row)">{{$t('编辑')}}</el-link>
<!--              <el-link :underline="false" type="danger" @click="handleDelete(row)">删除</el-link>-->
            </div>
          </template>
        </el-table-column>
      </table-list>
    </template>

    <template #other>
      <el-dialog :visible.sync="showDialog" :title="formData.code ? $t('编辑') : $t('新增')" :close-on-click-modal="false" @close="handleCloseFormDialog" width="600px">
        <el-form :model="formData" ref="form" :rules="formRule" label-width="120px">
          <el-form-item :label="$t('地区服务器名称')" prop="name">
            <el-input  :placeholder="$t('请输入地区服务器名称')" v-model="formData.name" :readonly="formData.code" />
          </el-form-item>
          <el-form-item :label="$t('推荐值算法')" prop="refRecommend">
            <el-select v-model="formData.refRecommend" :placeholder="$t('请选择推荐值算法')" clearable>
              <el-option v-for="item in recommendList" :key="item.code" :value="item.code" :label="item.name" />
            </el-select>
          </el-form-item>
        </el-form>
        <template #footer>
          <el-button type="primary" @click="handleSave">{{$t('保存')}}</el-button>
          <el-button @click="showDialog = false">{{$t('取消')}}</el-button>
        </template>
      </el-dialog>
    </template>

  </ankh-list>
</template>

<script>
import {request, requestByTip} from "@/config/request";
import TableList from "@/components/table-list/TableList";
import AnkhList from "@/components/list/AnkhList.vue";
export default {
  name: "AreaDataList",
  components: {AnkhList, TableList},
  data() {
    return {
      searchForm: {},
      tableData: [],
      selection: [],
      showDialog: false,
      formData: {
        code: null,
        name: "",
        refRecommend: ""
      },
      formRule: {
        name: {required: true, message: this.$t('请输入地区服务器名称'), trigger: "blur"},
        refRecommend: {required: true, message: this.$t('请选择推荐值算法'), trigger: "change"}
      },
      recommendList: []
    }
  },
  methods: {
    handleSave() {
      this.$refs.form.validate( async valid => {
        if(!valid) return;
        const action = this.formData.code ? this.$api.areaData.update : this.$api.areaData.add;

        await request(action, this.formData);
        this.$message.success(this.$t('操作成功'));
        this.$refs.list.handleRequest();
        this.showDialog = false;
      })
    },

    async handleChangeStatus(e, row) {
      try {
        const params = {...row};
        delete params.createTime;
        delete params.updateTime;
        await request(this.$api.areaData.update, params);
        this.$refs.list.handleRequest();
        this.$message.success(this.$t('操作成功'));
      } catch (e) {
        console.log(e);
      }
    },

    // 关闭弹窗
    handleCloseFormDialog() {
      this.formData = {code: null, name: "", refRecommend: ""};
    },

    handleEdit(row) {
      this.formData = {...row};
      delete this.formData.createTime;
      delete this.formData.updateTime;
      this.showDialog = true;
    },

    async handleDelete(row) {
      try {
        await requestByTip(this.$api.areaData.delete, {code: row.code});
        this.$message.success(this.$t('操作成功'))
        this.$refs.list.handleRequest(1);
      } catch (e) {
        console.error(e);
      }
    },

    async handleBatchDelete() {
      try {
        let codes = this.selection.map(item => item.code);
        if(!codes.length) {
          this.$message.warning(this.$t('请选择要删除的项'));
          return;
        }
        await requestByTip(
            this.$api.areaData.batchDelete,
            codes,
            {isJson: true},
            {message: this.$t('您现在正在进行批量删除操作, 是否继续?')}
        );
        this.$message.success(this.$t('操作成功'));
        this.$refs.list.handleRequest(codes.length);
      } catch (e) {
        console.error(e);
      }
    },

    async handleSearch(params, setTotal) {
      try {
        let res = await request(this.$api.areaData.list, params);
        for (let key in res) {
          if (res[key] instanceof Array) {
            this.tableData = res[key];
          }
        }
        setTotal(res.pager?.itemCount);
      } catch (e) {
        console.error(e);
      }
    },

    async loadRecommendList() {
      try {
        let res = await request(this.$api.recommend.list, {onPage: false});
        this.recommendList = res.recommends || [];
      } catch (e) {
        console.error(e);
      }
    }
  },
  created() {
    this.loadRecommendList();
  }
}
</script>

<style scoped>

</style>
